import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['en-US', 'ru-RU', 'es-MX', 'pt-BR', 'fr-FR', 'ar-AR', 'hi-IN', 'ko-KR', 'ja-JP'],
  defaultLocale: 'en-US',
  localePrefix: 'always',
  localeDetection: true
});